import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

import { baseRoutes } from '@/router/base';
import setupRoutesByRole from './setup-routes-by-role';
import { StorageService } from '../services/storage.service';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: baseRoutes,
});

router.beforeEach(async (to, from, next) => {
  StorageService.setAuthStateFromLocalStorage();

  if (StorageService.getLoginState() && StorageService.getUser() === null) {
    try {
      const res = await store.dispatch('auth/fetchMe')
      
      if (!res) throw null;

      if (res.status === 503) {
        StorageService.saveLoginState(false);

        return next('/login');
      }

      store.dispatch('menus/fetchMenus', {});

      const officeCategories = await store.dispatch(
        'office_categories/fetchOfficeCategories',
        {
          'fields[office-categories]':
            'name,cashback_jawa,cashback_luar_jawa,min_order_jawa,min_order_luar_jawa',
        }
      );

      if (!officeCategories) throw null;

      store.commit(
        'office_categories/setAvailableOfficeCategories',
        officeCategories.data.data
      );

      if (!(await store.dispatch('auth/fetchUserOfficeCategory'))) throw null;

      setupRoutesByRole(router);

      return next(to.path);
    } catch (err) {
      StorageService.saveLoginState(false);

      window.location.href = '/login'
    }
  } else if (to.path !== '/maintenance') {
    const res = await fetch('/api/v1')  

    if (!res.ok) {
      if (res.status === 503) {
        return next('/maintenance')
      }
    }
  }

  // Window Title on every page
  const company = ' | ERP Natural Nusantara';
  window.document.title =
    to.meta && to.meta.title ? to.meta.title + company : 'Home' + company;

  // Check Authentication
  if (to.matched.some((record) => record.meta.auth)) {
    if (!StorageService.getLoginState()) {
      window.location.href = '/login'
    } else {
      const menu = StorageService.getMenu()
      const withoutParent = to.matched.some(route => route.meta.withoutParent)

      if (typeof menu === 'string' || withoutParent) {
        next()
      } else {
        const currentMenu = menu.attributes.name
        const matchParent = to.matched.some(route => route.meta.parent === currentMenu)

        if (!matchParent) {
          next(`/${currentMenu.toLowerCase().split(' ').join('-')}`)
        } else {
          next();
        }
      }
    }
  } else if (to.matched.some((record) => record.meta.guest)) {
    if (StorageService.getLoginState()) {
      next('/');
    } else {
      next()
    }
  } else {
    next();
  }
});

/**
 * Remove navigation duplicate error
 * https://stackoverflow.com/questions/57837758/navigationduplicated-navigating-to-current-location-search-is-not-allowed
 */
const originalPush = router.push;
router.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }

  return originalPush.call(this, location).catch((err) => {
    if (VueRouter.isNavigationFailure(err)) {
      return err;
    }

    return Promise.reject(err);
  });
};

export default router;
